import 'unfetch';

var _excluded = ["company"],
    _excluded2 = ["id"],
    _excluded3 = ["user_id", "email", "phone", "signed_up_at", "name", "session_count", "companies", "custom_attributes", "unsubscribed_from_emails", "unsubscribed_from_calls"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* global _ctrack */
var defaultOpts = {
  scriptInclude: true
};
/**
 * Custify plugin
 * @link https://getanalytics.io/plugins/custify
 * @link https://docs.custify.com/
 * @link https://app.custify.com/settings/developer/js-snippet
 * @param {object} pluginConfig - Plugin settings
 * @param {string} pluginConfig.accountId - custify account ID
 * @param {boolean} [pluginConfig.scriptInclude = true] - Load custify script into page
 * @param {object}  [pluginConfig.options] - Custify script options
 * @return {AnalyticsPlugin}
 * @example
 *
 * // This will load crazy egg on to the page
 * custifyPlugin({
 *   accountId: '1234578'
 * })
 */

function custifyPlugin() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    name: 'custify',
    config: _objectSpread(_objectSpread({}, defaultOpts), pluginConfig),
    methods: {
      trackTime: function trackTime(pageName, idleTimer) {
        if (!_ctrack || typeof _ctrack.trackTime === 'undefined') {
          return;
        }

        _ctrack.trackTime(true, {
          module: pageName,
          idleTimer: idleTimer
        });
      },
      stopTrackTime: function stopTrackTime() {
        if (!_ctrack || typeof _ctrack.stopTrackTime === 'undefined') {
          return;
        }

        _ctrack.stopTrackTime();
      },
      setOptions: function setOptions(options) {
        if (!_ctrack || typeof _ctrack.setOptions === 'undefined') {
          return;
        }

        _ctrack.setOptions(options);
      }
    },
    initialize: function initialize(_ref) {
      var config = _ref.config;
      var accountId = config.accountId,
          scriptInclude = config.scriptInclude,
          options = config.options;

      if (!accountId) {
        throw new Error('No custify accountId defined');
      } // Create script & append to DOM


      var _ctrack = window._ctrack || [];

      if (scriptInclude) {
        var methods = ["identify", "track", "setInstance", "setAccount", "trackTime", "stopTrackTime", "debug", "setOptions"];
        _ctrack = methods.reduce(function (acc, method) {
          acc[method] = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            _ctrack.push([method].concat(args));
          };

          return acc;
        }, _ctrack);
        window._ctrack = _ctrack;
        var script = document.createElement('script');
        var firstScript = document.getElementsByTagName('script')[0];
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = 'https://assets.custify.com/assets/track.min.js';
        firstScript.parentNode.insertBefore(script, firstScript);
      }

      _ctrack.setAccount(accountId);

      if (options) {
        _ctrack.setOptions(options);
      }
    },
    identify: function identify(_ref2) {
      var payload = _ref2.payload;
      var userId = payload.userId,
          traits = payload.traits;

      if (typeof _ctrack === 'undefined' || !traits.email) {
        return;
      }

      var company = traits.company,
          user = _objectWithoutProperties(traits, _excluded);

      var properties = {
        userId: userId,
        email: user.email
      };

      if (company) {
        properties.company_id = company.id;
      }

      company.id;
          var companyRest = _objectWithoutProperties(company, _excluded2);

      var user_id = user.user_id,
          email = user.email,
          phone = user.phone,
          signed_up_at = user.signed_up_at,
          name = user.name,
          session_count = user.session_count,
          companies = user.companies,
          custom_attributes = user.custom_attributes,
          unsubscribed_from_emails = user.unsubscribed_from_emails,
          unsubscribed_from_calls = user.unsubscribed_from_calls,
          userRest = _objectWithoutProperties(user, _excluded3);

      custom_attributes = _objectSpread(_objectSpread({}, userRest), custom_attributes);
      var newUser = {
        user_id: user_id,
        email: email,
        phone: phone,
        signed_up_at: signed_up_at,
        name: name,
        session_count: session_count,
        companies: companies,
        custom_attributes: custom_attributes,
        unsubscribed_from_emails: unsubscribed_from_emails,
        unsubscribed_from_calls: unsubscribed_from_calls
      };

      _ctrack.identify(properties, {
        user: newUser,
        company: companyRest
      });
    },
    page: function page(_ref3) {
      var payload = _ref3.payload;
      if (typeof _ctrack === 'undefined') return;

      _ctrack.track('page-view', _objectSpread({}, payload.properties));
    },
    track: function track(_ref4) {
      var payload = _ref4.payload;
      if (typeof _ctrack === 'undefined') return;
      var event = payload.event,
          userId = payload.userId,
          properties = payload.properties;

      _ctrack.track(event, _objectSpread({
        userId: userId
      }, properties));
    },
    loaded: function loaded() {
      return !!window._ctrack;
    }
  };
}

/* This module will shake out unused code and work in browser and node 🎉 */

var index = custifyPlugin ;

export { index as default };
